import React, { Component } from 'react';
import { Layout, Menu, Icon, PageHeader, Divider } from 'antd';
import ComplexMenu from '../../components/complex_menu';
import { main_menu_list } from '..';
import SideMenu from '../../components/side_menu';
import MainLayout from '../main_layout';
import { getBreadcrumb } from '../../util/ui_util';
import { Switch,Route,Redirect } from 'react-router-dom';
import ReportInbox from './report_inbox';
import ReportArchived from './report_ archived';
import MyReportList from './my_reports';
import ReportCreator from './report_creator';
import ReportPluginList from './report_plugin_list';
import ReportDetail from './report_detail';
import { EmailOutlined, SettingsOutlined, PostAddOutlined, CardTravelOutlined } from '@material-ui/icons';

const { Header, Content, Footer, Sider } = Layout;
// const routes = [
//     {
//         path: 'reports',
//         breadcrumbName: 'Reports',
//     },
//     {
//         path: 'overview',
//         breadcrumbName: 'My Task',
//     },
//     {
//         path: 'second',
//         breadcrumbName: 'Task Detail',
//     },
// ];

class ReportsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sliderCollapse: false
        };
    };

    render() {
        const {sliderCollapse}=this.state;
        var pathName=this.props.location.pathname+this.props.location.search;
        console.log("top",pathName, this.props.location.search)

        return (
            <MainLayout 
            onRef={(ref) => {
                // console.log("changing reg", ref);
                window.slider_main = ref
            }}
            sliderContent={
                <SideMenu
                key="sidereports"
                menuKey={pathName}
                item={[
                    {
                        type:'main',
                        title:'Inbox',
                        url:'reports/inbox',
                        key:'inbox',
                        // iconName:'inbox',
                        icon:<EmailOutlined className='menu-icon'/>
                    },
                    {
                        type:'main',
                        title:'Archived',
                        url:'reports/archived',
                        key:'archived',
                        icon:<CardTravelOutlined className='menu-icon'/>
                    },
                    
                    {
                        type:'complex',
                        title:'Adhocs',
                        api_url:'/report-plugins',
                        key:'adhoc',
                        limit:5,
                        // no_search:true,
                        urlMaker:(item)=>`reports/adhoc/${item}`,
                        viewAll:'reports/adhoc',
                        icon:<PostAddOutlined className='menu-icon'/>,
                        key_position:3
                    },{
                        type:'main',
                        title:'Settings',
                        url:'reports/settings',
                        key:'settings',
                        // iconName:'setting',
                        icon:<SettingsOutlined className='menu-icon'/>
                    },
                    
                    
                ]}
                />
            }
            pageTitle={"Reports"}
            pageRoutes={{routes:getBreadcrumb(this.props.location.pathname)}}
            mainContent={
                <Switch>
                    <Route path='/reports/inbox/:report_id' component={ReportDetail}/>
                    <Route path='/reports/inbox' component={ReportInbox}/>
                    <Route path='/reports/archived/:report_id' component={ReportDetail}/>
                    <Route path='/reports/archived' component={ReportArchived}/>
                    <Route path='/reports/settings' component={MyReportList}/>
                    <Route path='/reports/adhoc/:adhoc_id' component={ReportCreator}/>
                    <Route path='/reports/adhoc' component={ReportPluginList}/>
                    <Redirect from='/reports' to='/reports/inbox' />
                </Switch>
            }
            />
        );
    }
}

export default ReportsPage;
